import { Modal } from '@doordash/component-modal'
import { Text, StackChildren } from '@doordash/design-language'
import * as React from 'react'

import t from './strings'

export const noBankAccountModal = props => (
  <Modal
    onClose={props.onClose}
    title={t.noBankModalTitle()}
    size={Modal.Sizes.Small}
    hasCloseButton={false}
    primaryAction={{
      text: t.noBankModalPrimaryAction(),
      onClick: () => props.onClose(),
    }}
    actionsFillContainer={true}
    isFullScreenOnMobile={false}
  >
    <StackChildren>
      <Text style={Text.Styles.SectionSubtext}>{t.noBankModalCopy1()}</Text>
      <Text style={Text.Styles.SectionSubtext}>{t.noBankModalCopy2()}</Text>
    </StackChildren>
  </Modal>
)
